export default __webpack_public_path__ + "static/media/phone.fa2821d8.png";